var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoQuota = function SvgIcoQuota(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    fill: "none",
    viewBox: "0 0 18 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EEE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.25 5.375C17.25 7.653 13.556 9.5 9 9.5S.75 7.653.75 5.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S.75 3.097.75 5.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125S.75 18.903.75 16.625V5.375m16.5 0v3.75M.75 5.375v3.75m16.5 0v3.75C17.25 15.153 13.556 17 9 17S.75 15.153.75 12.875v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125S.75 11.403.75 9.125"
  })));
};
export default SvgIcoQuota;